module.exports = __webpack_public_path__ + "img/go-to-grahak.3b870b27.jpg";